import * as firebase from 'firebase'
import 'firebase/firestore'
import 'firebase/analytics'

const firebaseConfig = {
  apiKey: 'AIzaSyD5JORgyGQmUvdsVzWF77AFwcJCsEVdRho',
  authDomain: 'akbarsdom-lk-d7d79.firebaseapp.com',
  databaseURL: 'https://akbarsdom-lk-d7d79.firebaseio.com',
  projectId: 'akbarsdom-lk-d7d79',
  storageBucket: 'akbarsdom-lk-d7d79.appspot.com',
  messagingSenderId: '483089721346',
  appId: '1:483089721346:web:50a576c47305b29904df1b',
  measurementId: 'G-LV1FRZHM2L'
}

firebase.initializeApp(firebaseConfig)
firebase.analytics()

export default firebase
